<script setup lang="ts">
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";

const { t, tm } = useI18n();

const openIndex = ref(0);

function toggle(index: number) {
  openIndex.value = openIndex.value === index ? -1 : index;
}

const faqs = computed(() => {
  const items = tm("faq.items") as Array<{ question: string; answer: string }>;
  return items.map((item) => ({
    question: item.question,
    answer: item.answer,
  }));
});
</script>

<template>
  <section class="bg-[var(--color-bg-primary)] px-5 py-12 md:px-12 md:py-24">
    <div class="mx-auto max-w-[var(--max-w-content)]">
      <h2
        data-reveal
        class="fade-up text-center text-2xl font-medium text-[var(--color-text-primary)] md:text-4xl"
        style="font-family: var(--font-display)"
      >
        {{ t("faq.heading") }}
      </h2>

      <div data-reveal data-reveal-delay="2" class="fade-up mt-10">
        <div v-for="(faq, i) in faqs" :key="i" class="border-b border-[var(--color-border)]">
          <button
            :id="`faq-trigger-${i}`"
            class="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left text-base font-medium text-[var(--color-text-primary)] md:text-lg"
            :aria-expanded="openIndex === i"
            :aria-controls="`faq-panel-${i}`"
            @click="toggle(i)"
          >
            <span>{{ faq.question }}</span>
            <UIcon
              name="i-lucide-plus"
              class="size-5 shrink-0 text-[var(--color-text-muted)] transition-transform duration-200"
              :class="openIndex === i ? 'rotate-45' : ''"
            />
          </button>

          <div
            :id="`faq-panel-${i}`"
            role="region"
            :aria-labelledby="`faq-trigger-${i}`"
            class="grid transition-all duration-300 ease-[var(--ease-smooth)]"
            :class="openIndex === i ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'"
          >
            <div class="overflow-hidden">
              <p
                class="pb-5 text-[15px] leading-[1.7] text-[var(--color-text-secondary)] md:text-base"
              >
                {{ faq.answer }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
